import React, { forwardRef } from 'react';

interface HeartFullProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const HeartFull = forwardRef<HTMLElement, HeartFullProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-heart ${classes || ''}`} style={style}></i>
  );
});

HeartFull.displayName = 'HeartFull';
